
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type vehicleLabelContainerRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function vehicleLabelContainerRT(): TemplateResult<vehicleLabelContainerRTRootProps> {
    return _createElement('div', { 'className': 'cm_model-selector category' }, this.template === 'locked' ? _createElement('div', {
        'className': 'locked-container cmTemplate_locked',
        'key': '43'
    }, _createElement('div', { 'className': 'model-selector-title' }, '\n  ', this.vehicleString, '\n  ', _createElement('span', { 'className': 'model-selector-subtitle' }, this.fitmentSearchTitle)), _createElement('div', { 'className': 'model-selector-body' }, _createElement('div', { 'className': 'buttons-container' }, _createElement('div', {
        'className': 'cm_button button button--primary',
        'onClick': this.openDialog
    }, '\n      ', _translate(`ymm_bar_change`), '\n    '), _createElement('div', {
        'className': 'button button--primary',
        'id': 'themevale_clear-select',
        'title': 'Reset',
        'onClick': this.discardVehicle
    }, _createElement('svg', { 'className': 'icon' }, _createElement('use', { 'xlinkHref': '#icon-refresh' })))))) : null);
}
        export const componentNames = []